import React, { Component } from 'react';
import ValidationText from '../../utils/validation/ValidationText.js';
import { CommonValidationMessages } from '../../utils/Messages.js';
import { isValidForm } from '../../utils/validation/CommonValidator.js';
import CommonServices from '../../services/axioServices/apiServices/CommonServices.js';
import SwalServices from '../../services/swalServices/SwalServices.js';
import AccountServices from '../../services/axioServices/apiServices/AccountServices.js';
import moment from 'moment';
import { FinancealYearStartDateEndDate } from '../../utils/FinancialYearStartDateEndDate.js';

class CashBankBook extends Component {
    constructor(props) {
        super(props);
        this.commonServices = new CommonServices();
        this.SwalServices = new SwalServices();
        this.accountServices = new AccountServices();
        this.state = {
            filterDetails: {
                startDate: "",
                endDate: "",
            },
            openingBalance: '',
            bankName: "",
            tableName: "bankWise",
            tableStatus: "",
            totalCreditAmount: '',
            totalDebitAmount: '',
            closingBalance: '',
            // tableName: "monthWise",
            // tableName: "dateWise",
            cashBankList: [],
            monthWiseReportList: [],
            bankWiseReportList: [],
            dateWiseReportList: [],
            validationRules: {
                startDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "start date"
                        ),
                    },
                ],
                endDate: [
                    {
                        type: "require",
                        message: CommonValidationMessages.FieldRequired.replace(
                            "{0}",
                            "end date"
                        ),
                    },
                ],
            },
            validState: {
                isValid: true,
                error: {},
            },
        };
    }

    componentDidMount() {
        let dates = FinancealYearStartDateEndDate()
        let filterDetails = this.state.filterDetails
        filterDetails.startDate = dates.startDate
        filterDetails.endDate = dates.endDate
        this.setState({ filterDetails: filterDetails }, () => {
            this.getAllBankWiseCashBankBookReport()
        })
    }

    getAllBankWiseCashBankBookReport = () => {
        this.setState({ tableStatus: "Loading..." }, () => {
            let request = [this.state.filterDetails.startDate, this.state.filterDetails.endDate]
            this.accountServices.getAllBankWiseCashBankBookReport(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    this.setState({ bankWiseReportList: response.responseData })
                } else {
                    this.setState({ tableStatus: "" })
                    this.SwalServices.Error(response.Message)
                }
            });
        })
    }

    getAllCashBankBook = () => {
        let isValidAllFields = this.isValidAllFields();
    }
    isValidAllFields = () => {
        const newValidState = isValidForm(
            this.state.filterDetails,
            this.state.validationRules,
            this.state.validState
        );
        this.setState({ validState: newValidState });
        return newValidState.isValid;
    };
    resetForm = () => {
        let validState = this.state.validState
        validState.isValid = true
        validState.error = {}
        let Fdetails = this.state.filterDetails
        Fdetails.startDate = ""
        Fdetails.endDate = ""
        this.setState({
            filterDetails: Fdetails
        });
    }
    openPrevPage = () => {
        if (this.state.tableName === "monthWise") {
            this.setState({ tableName: "bankWise" })
        } else if (this.state.tableName === "dateWise") {
            this.setState({ tableName: "monthWise" })
        }
    }
    handleChange = (event, name, section) => {
        let value = event.target.value;
        let details = this.state.filterDetails;
        details[name] = value.toUpperCase();
        this.setState({ filterDetails: details }, () => {
            this.getAllBankWiseCashBankBookReport()
            this.setState({ tableName: "bankWise" });
        });
    };

    getAllMonthWiseCashBankBookReportbyBankId = (id, bankName) => {
        this.setState({ tableStatus: "Loading...", tableName: 'monthWise' }, () => {
            let request = [id, this.state.filterDetails.startDate, this.state.filterDetails.endDate]
            this.accountServices.getAllMonthWiseCashBankBookReportbyBankId(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    this.setState({ monthWiseReportList: response.responseData }, () => {
                        if (response.responseData.length === 0) {
                            this.setState({ tableStatus: "No Record Found" })
                        } else {
                            this.setState({ tableStatus: "" })
                        }
                        this.setState({ bankName: bankName })
                    })
                } else {
                    this.setState({ tableStatus: "" })
                    this.SwalServices.Error(response.Message)
                }
            });
        })
    }

    getAllDateWiseCashBankBookReportbyBankId = (id, startDate, endDate, openingBalance) => {
        this.setState({ tableStatus: "Loading...", tableName: 'dateWise' }, () => {
            let request = {
                bankId: id,
                startDate: startDate,
                endDate: endDate
            }
            this.accountServices.getAllDateWiseCashBankBookReportbyBankId(request).then((response) => {
                if (response.statusCode === 200 && response.responseData != null) {
                    let accountLedgerList = this.calculateRunningBalance(Number(openingBalance), response.responseData)
                    let totalCreditAmount = accountLedgerList.reduce((sum, item) => sum + Number(item.creditAmount), 0);
                    let totalDebitAmount = accountLedgerList.reduce((sum, item) => sum + Number(item.debitAmount), 0);
                    let totalClosing = (totalCreditAmount + openingBalance) - totalDebitAmount
                    if (response.responseData.length === 0) {
                        this.setState({ tableStatus: "No Record Found" })
                    } else {
                        this.setState({ tableStatus: "" })
                    }
                    this.setState({ dateWiseReportList: accountLedgerList, totalCreditAmount: totalCreditAmount, totalDebitAmount: totalDebitAmount, closingBalance: Number(totalClosing).toFixed(2) }, () => {
                        this.setState({ openingBalance: openingBalance })
                    })
                } else {
                    this.setState({ tableStatus: "" })
                    this.SwalServices.Error(response.Message)
                }
            });
        })
    }

    calculateRunningBalance(openingBalance, transactions) {
        let runningBalance = openingBalance

        return transactions.map((transaction) => {
            const credit = Number(transaction.creditAmount) || 0;
            const debit = Number(transaction.debitAmount) || 0;

            runningBalance += credit;
            runningBalance -= debit;

            return {
                ...transaction,
                creditAmount: credit,
                debitAmount: debit,
                // runningBalance: Math.abs(runningBalance),
                runningBalance: runningBalance,
            };
        });
    }

    render() {
        return (
            <div className='CashBankBook-page'>
                <div className="item-search flex gap-2.5 !mb-3.5">
                    <div className="input-grp  w-[20%]" >
                        <label>Start Date</label>
                        <input
                            className="inputFocus"
                            type="date"
                            id="startDate"
                            name="startDate"
                            autoComplete="off"
                            // disabled={true}
                            value={this.state.filterDetails.startDate}
                            onChange={(event) =>
                                this.handleChange(event, "startDate")
                            }
                        />
                        {/* <ValidationText
                            error={this.state.validState.error.startDate}
                        /> */}
                    </div>
                    <div className="input-grp w-[20%]">
                        <label>End Date</label>
                        <input
                            className="inputFocus"
                            type="date"
                            id="endDate"
                            name="endDate"
                            autoComplete="off"
                            // disabled={true}
                            value={this.state.filterDetails.endDate}
                            onChange={(event) =>
                                this.handleChange(event, "endDate")
                            }

                        />
                        {/* <ValidationText
                            error={this.state.validState.error.endDate}
                        /> */}
                    </div>

                    <div className="btn-grp mt-auto">
                        {/* <button
                            className={`add-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`}
                            onClick={() => this.getAllCashBankBook()}
                            disabled={this.state.tableName !== "bankWise"}
                        > Search
                        </button>

                        <button
                            className={`cancel-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`}
                            onClick={() => this.resetForm()}
                            disabled={this.state.tableName !== "bankWise"}
                        >Cancel
                        </button> */}

                        {this.state.cashBankList > 0 ?
                            <button
                                className={`print-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`}
                                onClick={() => this.resetForm()}
                            >Print
                            </button> : null}

                        {this.state.tableName !== "bankWise" ?
                            <button
                                className={`back-btn ${(this.state.validState.isValid === false) ? 'mb-[12px]' : 'mb-0'}`}
                                onClick={() => this.openPrevPage()}
                            >Back
                            </button>
                            : null}

                    </div>

                </div>
                {this.state.tableName !== "bankWise" ?
                    <div className="table-upper mt-2.5 flex justify-between">
                        <p className="mb-[3px] text-[15px] font-medium text-[#474747]" >
                            Bank Name:- {this.state.bankName}
                        </p>
                        {this.state.tableName === 'dateWise' ?
                            <p className="mb-[3px] text-[15px] font-medium text-[#474747] mr-[2px]" >
                                Opening Balance:- {Number(this.state.openingBalance).toFixed(2)}
                            </p>
                            : null}
                    </div> : null}

                {this.state.tableName === "bankWise" ?
                    <div class="item-listing">
                        <div class="itemList-table ">
                            <div class="table-container" style={{ height: "calc(100vh - 125px)" }} >
                                <table class="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[28%]'>Cash/Bank Name</td>
                                            <td className='w-[18%]'>Opening Balance</td>
                                            <td className='w-[18%]'>Receipt</td>
                                            <td className='w-[18%]'>Payment</td>
                                            <td className='w-[18%]'>Closing Balance</td>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.bankWiseReportList && this.state.bankWiseReportList.length > 0 ? (
                                            this.state.bankWiseReportList.map((details, key) => (
                                                <tr
                                                    key={key}
                                                    className="hover:bg-gray-200 cursor-pointer "
                                                    onClick={() => this.getAllMonthWiseCashBankBookReportbyBankId(details.bankId, details.bankName)}
                                                >
                                                    <td>{details.bankName}</td>
                                                    <td>{Number(details.openingBalance).toFixed(2)}</td>
                                                    <td>{Number(details.totalCreditAmount).toFixed(2)}</td>
                                                    <td>{Number(details.totalDebitAmount).toFixed(2)}</td>
                                                    <td>{Number(details.closingBalance).toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : this.state.bankWiseReportList &&
                                            this.state.bankWiseReportList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.bankWiseReportList &&
                                            this.state.bankWiseReportList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                    : this.state.tableName === "monthWise" ?
                        <div class="itemList-table ">
                            <div class="table-container" style={{ height: "calc(100vh - 150px)" }} >
                                <table class="itemList">
                                    <thead>
                                        <tr>
                                            <td className='w-[28%]'>Month</td>
                                            <td className='w-[18%]'>Opening Balance</td>
                                            <td className='w-[18%]'>Receipt</td>
                                            <td className='w-[18%]'>Payment</td>
                                            <td className='w-[18%]'>Closing Balance</td>

                                        </tr>
                                    </thead>
                                    <tbody>
                                        {this.state.monthWiseReportList
                                            && this.state.monthWiseReportList.length > 0 ? (
                                            this.state.monthWiseReportList.map((details, key) => (
                                                <tr
                                                    key={key}
                                                    className="hover:bg-gray-200 cursor-pointer "
                                                    onClick={() => this.getAllDateWiseCashBankBookReportbyBankId(details.bankId, details.startDate, details.endDate, details.openingBalance)}
                                                >
                                                    <td>{details.month}</td>
                                                    <td>{Number(details.openingBalance).toFixed(2)}</td>
                                                    <td>{Number(details.receipt).toFixed(2)}</td>
                                                    <td>{Number(details.payment).toFixed(2)}</td>
                                                    <td>{Number(details.closingBalance).toFixed(2)}</td>
                                                </tr>
                                            ))
                                        ) : this.state.monthWiseReportList &&
                                            this.state.monthWiseReportList.length === 0
                                            && this.state.tableStatus !== "" ? (
                                            <tr>
                                                <td colSpan={5} style={{ textAlign: "center", fontSize: "16px" }}>
                                                    {this.state.tableStatus}
                                                </td>
                                            </tr>
                                        ) : this.state.monthWiseReportList &&
                                            this.state.monthWiseReportList.length === 0
                                            && this.state.tableStatus === "" ? null : ""}
                                    </tbody>
                                </table>
                            </div>
                        </div>
                        : this.state.tableName === "dateWise" ?
                            <div class="itemList-table ">
                                <div class="table-container " style={{ height: "calc(100vh - 245px)" }}  >
                                    <table class="itemList">
                                        <thead>
                                            <tr>
                                                <td className='w-[10%]'>Vou. No.</td>
                                                <td className='w-[10%]'>Date</td>
                                                <td className='w-[20%]'>Description</td>
                                                <td className='w-[15%]'>Cheque No.</td>
                                                <td className='w-[15%]'>Receipt</td>
                                                <td className='w-[15%]'>Payment</td>
                                                <td className='w-[15%]'>Balance</td>

                                            </tr>
                                        </thead>
                                        <tbody>
                                            {this.state.dateWiseReportList
                                                && this.state.dateWiseReportList.length > 0 ? (
                                                this.state.dateWiseReportList.map((details, key) => (
                                                    <tr
                                                        key={key}
                                                    >
                                                        <td>{details.voucherNo}</td>
                                                        <td>{moment(details.date).format('DD-MM-YYYY')}</td>
                                                        <td>{details.partyId?.partyName ? details.partyId?.partyName : ''}</td>
                                                        <td>{details.chqNo}</td>
                                                        <td>{Number(details.creditAmount).toFixed(2)}</td>
                                                        <td>{Number(details.debitAmount).toFixed(2)}</td>
                                                        <td>{Number(details.runningBalance).toFixed(2)}</td>
                                                    </tr>
                                                ))
                                            ) : this.state.dateWiseReportList &&
                                                this.state.dateWiseReportList.length === 0
                                                && this.state.tableStatus !== "" ? (
                                                <tr>
                                                    <td colSpan={7} style={{ textAlign: "center", fontSize: "16px" }}>
                                                        {this.state.tableStatus}
                                                    </td>
                                                </tr>
                                            ) : this.state.dateWiseReportList &&
                                                this.state.dateWiseReportList.length === 0
                                                && this.state.tableStatus === "" ? null : ""}
                                        </tbody>
                                    </table>
                                </div>
                                <div className="item-sections w-[45%] rounded-[10px] ml-auto mt-3 !p-3  !bg-white " style={{ boxShadow: 'rgba(0, 0, 0, 0.16) 0px 1px 4px', backgroundColor: "#f5f5f5" }}>
                                    <div className='flex gap-2.5 '>
                                        <div className=" w-full">
                                            <label>Total Credit</label>
                                            <input
                                                className='h-[36px]'
                                                type="number"
                                                id="totalCredit"
                                                name="totalCredit"
                                                autocomplete="off"
                                                disabled
                                                value={this.state.totalCreditAmount}
                                            />
                                        </div>
                                        <div className=" w-full">
                                            <label>Total Debit</label>
                                            <input
                                                className='h-[36px]'
                                                type="number"
                                                id="totalDebit"
                                                name="totalDebit"
                                                autocomplete="off"
                                                disabled
                                                value={this.state.totalDebitAmount}
                                            />
                                        </div>

                                        <div className=" w-full">
                                            <label>Total Closing Balance</label>
                                            <input
                                                className='h-[36px]'
                                                type="text"
                                                id="totalCloseBal"
                                                name="totalCloseBal"
                                                autocomplete="off"
                                                disabled
                                                value={this.state.closingBalance}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div> : null}
            </div>
        );
    }
}

export default CashBankBook;